import { VisaBookingsItem } from "../VisaBookings"
import { ITrip } from "./store"

type TVisaBookingProps = {
	trip: ITrip
}

export default function VisaBookings(props: TVisaBookingProps) {
	const { trip } = props
	return <VisaBookingsItem trip={trip} />
}
